export interface FieldLabelProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  /** Renders "(optional)" (bold variant) or "(OPTIONAL)" (caps variant) after the label. */
  optional?: boolean;
  /**
   * `caps` (default) = compliant input label per ui-guidelines.md §4 (12px
   * uppercase slate, semibold, 0.08em tracking). `bold` = legacy semibold
   * navy style, explicit opt-in only (e.g. a heavier section/card title that
   * happens to reuse this component) — do not use it for new input labels.
   */
  variant?: 'bold' | 'caps';
}

const VARIANT_CLASSES: Record<NonNullable<FieldLabelProps['variant']>, string> = {
  bold: 'font-sans text-sm font-semibold text-navy',
  caps: 'font-sans text-[12px] font-semibold uppercase tracking-[0.08em] text-slate',
};

/** Visible label rendered above a form field. */
export function FieldLabel({
  label,
  htmlFor,
  required = false,
  optional = false,
  variant = 'caps',
}: FieldLabelProps) {
  return (
    <label htmlFor={htmlFor} className={VARIANT_CLASSES[variant]}>
      {label}
      {required && (
        <span aria-hidden="true" className="ml-0.5 text-danger">
          *
        </span>
      )}
      {optional && (
        <span className={variant === 'caps' ? '' : 'ml-1 font-normal text-navy/70'}>
          {variant === 'caps' ? ' (OPTIONAL)' : ' (optional)'}
        </span>
      )}
    </label>
  );
}
